export default "__VITE_ASSET__CGEVxY0q__"